
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mapa-strony",
      function () {
        return require("private-next-pages/mapa-strony/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mapa-strony"])
      });
    }
  